import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { User } from 'types'

export const getUser = async (tableName: string, id: string) => {
  try {
    const url = `${baseUrl}/aws/users/${id}`
    const response = await axios.get(url, {
      params: id ? {} : { table: tableName }, // Params are only needed for fetching all items
    })
    if (response.status === 204) {
      return { data: id ? {} : [], status: 204 }
    } else {
      return response.data || []
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    return [] // Return an empty array in case of an error
  }
}

export const useUser = (userId, queryString = 'user') => {
  const { data: user, isLoading, isError }: UseQueryResult<User | undefined> = useQuery({
    queryKey: [queryString, userId], // Use consistent query key
    queryFn: () => getUser('users', userId),
    staleTime: Infinity, // Optional: adjust based on your caching needs
    gcTime: 1000 * 60 * 10, // Cache data for 10 minutes
    enabled: !!userId, // Only fetch if userId is provided
  })

  return { user, isLoading, isUserLoading: isLoading, isError, isUserError: isError }
}
